import { c as _c } from "react/compiler-runtime";
import { Tooltip } from 'platform/components';
import { useFormatNumber } from 'platform/locale';
import { isNotNil } from 'ramda-adjunct';
import { CellRendererProps } from '../../types/CellRendererProps';
import { TooltipGetter } from '../../types/TooltipGetter';
import { getCellClassName } from '../../utils/getCellClassName';
import { getTooltipProps } from '../../utils/getTooltipProps';
type IntegerCellRendererProps = CellRendererProps<number | null> & {
  getTooltipProps?: TooltipGetter;
};
export function IntegerCellRenderer(props) {
  const $ = _c(15);
  let t0;
  if ($[0] !== props.column) {
    t0 = getCellClassName(props.column);
    $[0] = props.column;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const className = t0;
  const formatNumber = useFormatNumber();
  let t1;
  if ($[2] !== props.getTooltipProps || $[3] !== props.row) {
    t1 = getTooltipProps(props.row, {}, props.getTooltipProps);
    $[2] = props.getTooltipProps;
    $[3] = props.row;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  const tooltipProps = t1;
  let t2;
  if ($[5] !== formatNumber || $[6] !== props.value) {
    t2 = isNotNil(props.value) ? formatNumber(Number(props.value), 0) : "";
    $[5] = formatNumber;
    $[6] = props.value;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  const value = t2;
  let t3;
  if ($[8] !== className || $[9] !== value) {
    t3 = <div className={className}>{value}</div>;
    $[8] = className;
    $[9] = value;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  let t4;
  if ($[11] !== t3 || $[12] !== tooltipProps || $[13] !== value) {
    t4 = <Tooltip {...tooltipProps} label={value}>{t3}</Tooltip>;
    $[11] = t3;
    $[12] = tooltipProps;
    $[13] = value;
    $[14] = t4;
  } else {
    t4 = $[14];
  }
  return t4;
}